import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactList from 'react-list';
import SelectionListItem from './selection-list-item/SelectionListItem';
import './SelectionList.scss';
import { VITE_MSIE11 } from 'Constants/appEnvConstants';

const SelectionList = ({ dataList, extraClass, handleSelect, visible, searchTerm, selectedTerm, selectedItems }) => {
  const wrapperClass = classnames('selection-list', {
    [extraClass]: extraClass,
  });

  const itemRenderer = (index) => {
    const item = Object.assign({}, dataList[index]);
    // eslint-disable-next-line eqeqeq
    const selected = item.selected || (selectedItems && selectedItems.some((i) => i.id == item.id));
    return (
      <SelectionListItem
        role="menu"
        key={item.id}
        itemId={item.id}
        mainLine={item.mainLine}
        subLine={item.subLine}
        selected={selected}
        handleSelect={handleSelect}
      />
    );
  };

  const containerRenderer = (items, ref) => {
    return (
      <ol className="selection-list-items" ref={ref}>
        {items}
      </ol>
    );
  };
  // eslint-disable-next-line no-undef
  const styles = VITE_MSIE11 ? { 'overflow-y': 'auto', maxWidth: 200, minWidth: 110, maxHeight: 400, '-ms-overflow-style': '-ms-autohiding-scrollbar' } : {};
  if (visible || (searchTerm !== '' && selectedTerm === '')) {
    return (
      <div className={wrapperClass} style={styles}>
        <ReactList
          itemsRenderer={containerRenderer}
          itemRenderer={itemRenderer}
          type="uniform"
          useStaticSize
          length={dataList.length}
        />
      </div>
    );
  } else {
    return null;
  }
};

SelectionList.propTypes = {
  dataList: PropTypes.array.isRequired,
  handleSelect: PropTypes.func.isRequired,
  extraClass: PropTypes.string,
  visible: PropTypes.bool,
  searchTerm: PropTypes.string,
  selectedItems: PropTypes.array,
};

SelectionList.defaultProps = {
  extraClass: '',
  visible: true,
  searchTerm: '',
  selectedItems: [],
};

export default SelectionList;
